<div class="agent-state-container d-flex justify-content-between align-items-center">
    <div class="d-flex my-0"> 
        <div class="status-icon"  [style.display]="hideStatusIcon" [style.background-color]="color"></div> 
        <div class="agent-state-name">{{value}}</div>
    </div>
    <svg *ngIf="dialerVisibility" class="icon-16" id="outbound-dialer-icon">
        <use href="../App_Themes/CXone/icons/outbound-dialer.svg#outbound-dialer"></use>
    </svg>
</div>
    